export const unpay_process = () => {
  return process.env.REACT_APP_USER_SERVER + "/change/unpay_update";
};

const post_api = {
  unpay_process,
};

export default post_api;
